const toDateString = (value) => {
    const d = new Date(value);
    const year = `${d.getFullYear()}`;
    let month = `${d.getMonth() + 1}`;
    let date = `${d.getDate()}`;
    month = month.length === 1 ? `0${month}` : month;
    date = date.length === 1 ? `0${date}` : date;
    return [year, month, date].join('-');
};

const toShortDateString = (value) => {
    const d = new Date(value);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1);
    // return year + strings.get('ext.years') + month + strings.get('util.month');
    return year + month;
};

const toTimeString = (value, unit) => {
    const d = new Date(value);
    let hour = `${d.getHours()}`;
    let min = `${d.getMinutes()}`;
    let sec = `${d.getSeconds()}`;
    hour = hour.length === 1 ? `0${hour}` : hour;
    min = min.length === 1 ? `0${min}` : min;
    sec = sec.length === 1 ? `0${sec}` : sec;
    if (unit === 'minute') {
        return [hour, min].join(':');
    }
    return [hour, min, sec].join(':');
};


export default {
    getWithParams(str, arg) {
        let p = [];
        let i;
        if (!str) throw new Error('string is not defined');

        // 处理参数
        if (arg[1] && (arg[1] instanceof Array)) {
            p = arg[1];
            return this.getWithParams0(str, p);
        }
        if (arg.length > 1) {
            for (i = 0; i < arg.length; i++) {
                p.push(arg[i]);
            }
        }
        return this.getWithParams0(str, p);
    },
    getWithParams0(s, p) {
        let str = s;
        let i;

        for (i = 0; i < p.length; i++) {
            str = str.replace(new RegExp(`\\{${i}\\}`, 'g'), p[i]);
        }
        return str;
    },
    date(value) {
        if (!value) return '-';
        return toDateString(value);
    },

    time(value, unit) {
        if (!value) return '';
        return toTimeString(value, unit);
    },
    monthDay(value) {
        let v = value;
        let arr = [];
        if (!v) return '';
        v = toDateString(value);
        arr = v.split('-');
        return `${arr[1]}-${arr[2]}`;
    },
    dateTime(value) {
        if (!value) return '';
        return `${toDateString(value)} ${toTimeString(value)}`;
    },

    dateMinute(value, flagFilterMinute) {
        let v = value;
        if (!v) return '';
        v = Number(new Date(value).getTime());
        if (flagFilterMinute) return `${toDateString(v)}`;
        return `${toDateString(v)} ${toTimeString(v, 'minute')}`;
    },
    // xxxx年xx月
    yearMonth(value) {
        const v = value;
        if (!v) return '';
        return toShortDateString(value);
    },
    // value: yyyy-MM
    firstDay(value) {
        let v = value;
        if (!v) return '';
        v = Number(new Date(value).getTime());
        return toDateString(v);
    },
    // value: yyyy-MM
    lastDay(value) {
        const v = value;
        let tempDate;
        if (!v) return '';
        tempDate = new Date(value);
        tempDate.setMonth(tempDate.getMonth() + 1);
        tempDate = tempDate.getTime() - (1000 * 60 * 60 * 24);
        return toDateString(tempDate);
    },
    restoreNumber(value, n) {
        /* eslint-disable */
        if (value && !isNaN(n)) return value / n;
        return parseFloat((value / 100).toFixed(2));
    },

    // 数字保留n位小数点的时候
    restoreNumberFixed(val, m, n) {
        let value;
        if (!val) return '-';
        if (val && n && m) {
            value = `${val / m}`;
            return value.indexOf('.') > 0 ? Number(value).toFixed(n) : Number(value);
        }
        value = `${val / 100}`;
        return value.indexOf('.') > 0 ? Number(value).toFixed(2) : Number(value);
    },
    // 数字保留n位小数点的时候 带提醒的
    restoreNumberFixedWarn(val, m, n, w) {
        let value;
        if (!val) return w;
        if (val && n && m) {
            value = `${val / m}`;
            return value.indexOf('.') > 0 ? Number(value).toFixed(n) : Number(value);
        }
        value = `${val / 100}`;
        return value.indexOf('.') > 0 ? Number(value).toFixed(2) : Number(value);
    },


    times() {
        /* eslint-disable */
        var fn, ret = [], i, count = 1, start, end, options, that = this;
        if (arguments.length === 2) {
            start = 0;
            end = arguments[0];
            options = arguments[1];
        } else {
            start = arguments[0];
            end = arguments[1];
            options = arguments[2];
        }
        fn = options.fn;

        function execIteration (index) {
            var innerData = D.assign({ count: count, index: index }, that);
            ret.push(fn(innerData));
            count++;
        }
        for (i = start; i < end; i++) {
            execIteration(i);
        }
        return ret.join('');
    },

    downloadUrl: function(fileId, options) {
        var Self = arguments[arguments.length - 1].data.root.Self,
            rootPath = Self.app.options.urlRoot,
            url = rootPath + '/human/file/download?id=' + fileId;
        return fileId && url;
    },
    secondToMinute: function(time) {
        var parseInt = window.parseInt;
        var second = time;
        var min = 0; // 分
        var hour = 0; // 小时
        var supple = function(str) {
            if (str <= 9) return '0' + str;
            return str;
        };
        if (!time) return '-';
        if (time >= 60) {
            second = parseInt(time % 60);
            min = parseInt(time / 60);
            if (min >= 60) {
                min = parseInt(time / 60) % 60;
                hour = parseInt(parseInt(time / 60) / 60);
            }
        }
        return supple(hour) + ':' + supple(min) + ':' + supple(second);
    },
    dateMinuteTrend: function(value) { // 按照动态时间格式化时间显示：今日、昨日等
        var v = value;
        if (!v) return '';
        if (!/^\d+$/.test(v)) v = v.replace(/-/g, '/');
        var date = new Date(v);
        v = Number(date.getTime());
        var todayDate = new Date();
        var days = parseInt((todayDate.getTime() - v) / 86400000);
        var today = todayDate.getDate();
        var year = date.getFullYear();
        var currentYear = todayDate.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var result, offset;
        offset = Math.abs(today - day);
        if (days < 2 && offset < 2 ) {
            if (offset === 0) {
                result = "今日 " + toTimeString(v, 'minute');
            } else if (offset === 1) {
                result = "昨日 " + toTimeString(v, 'minute');
            }
        } else if ( year === currentYear ) { // 同一年的显示：月-日 时：分
            result = month + "-" + day + ' ' + toTimeString(v, 'minute');
        } else { // 年-月-日 时：分
            result = toDateString(v) + ' ' + toTimeString(v, 'minute');
        }
        return result;
    },
    // 转时间戳
    dateToTimeMillis: function(value) {
        var v = value;
        if (!v) return 0;
        // 如果不是数值，那么就是已经格式化好的字符串
        // 兼容IE、fireFox处理
        if (!isNaN(new Date(v).getTime())) return new Date(v).getTime();
        return new Date(v.replace(/-/g, '/')).getTime();
    },
    // 秒转换成分钟
    secondsToMinutes: function(seconds) {
        return parseInt(seconds / 60, 10);
    },
    // 秒转换成分钟(忽略掉小时)
    secondsToMinutesWithIgnoreHours: function(seconds) {
        var minutes = this.secondsToMinutes(seconds),
            hours = this.minutesToHours(minutes, true);
        return (minutes - (hours * 60));
    },
    secondsToHours: function(seconds) {
        return this.minutesToHours(this.secondsToMinutes(seconds), true);
    },
    secondsToHoursWithDecimal: function(seconds) {
        return (seconds / 3600).toFixed(2);
    },
    // 分钟转换成小时
    minutesToHours: function(minutes, isFixed) {
        return isFixed ? parseInt(minutes / 60, 10) : (minutes / 60).toFixed(2);
    },
    minutesToMinutesWithIgnoreHours: function(minutes) {
        return minutes - ((this.minutesToHours(minutes, true)) * 60);
    },
    // 秒转换成x小时x分
    minutesToHoursWithMinutes: function(minute) {
        let minutes;
        const hour = Math.floor((minute / 3600) % 24);
        const min = Math.floor((minute / 60) % 60);
        const sec = Math.floor(minute % 60);
        if (hour >= 0) {
            minutes =  hour<10 ?  `0${hour}:` : `${hour}:`
        }
        if (min >= 0)  {
            minutes += min <10?  `0${parseFloat(min)}:` : `${parseFloat(min)}:`
        }
        if (sec >=0) {
            minutes += sec<10? `0${sec}`: sec
        }
        // 这个测试说考虑课程，专题显示不合理， 改成显示‘-’
        if(minutes==="00:00:00"||minutes ===undefined) return '-' 
        return !minutes ? "00:00:00": minutes;
    },

    // 过滤xss攻击
    echoX: function() {
        var key, content = '';
        for(key in arguments){

            if(arguments[key] && arguments[key] !== '' && (typeof arguments[key] === 'string')){
                content += window.myXss(arguments[key]);
            }
        }
        return content;
    },

     // 数字保留n位小数点的时候
    restoreNumberFixed: function(val, m, n) {
        var value;
        if (!val) return '-';
        if (val && n && m) {
            value = (val / m) + '';
            return value.indexOf('.') > 0 ? Number(value).toFixed(n) : Number(value);
        }
        value = (val / 100) + '';
        return value.indexOf('.') > 0 ? Number(value).toFixed(2) : Number(value);
    },
    // 只保留小数点后1位
    clearDecimal: function(value) {
        var val = value;
        val = val.replace(/[^\d.]/g, '');  // 清除“数字”和“.”以外的字符
        val = val.replace(/^\./g, '');  // 验证第一个字符是数字而不是.
        val = val.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
        val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        val = val.replace(/^(-)*(\d+)\.(\d).*$/, '$1$2.$3');// 只能输入两个小数
        if (val.indexOf('.') < 0 && val !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            val = parseFloat(val);
        }
        return val;
    },
    // 给数字加三位一逗号间隔
    fromatNumber: function(value) {
        var b=parseInt(value).toString();
        var len=b.length;
        if(len<=3){return b;}
        var r=len%3;
        return r>0?b.slice(0,r)+","+b.slice(r,len).match(/\d{3}/g).join(","):b.slice(r,len).match(/\d{3}/g).join(",");
    },
    // 字符串超出5位截取
    cutstring: function(value) {
        if (value.length > 5) {
            return value.slice(0, 5) + '...';
        }
        return value;
    },
    // 字符串超出7位截取
    cutString: function(value) {
        if (value.length > 7) {
            return value.slice(0,7) +'...';
        }
        return value;
    },
    // 字符串超出16位截取
    cutStrings: function(value) {
        if (value.length > 16) {
            return value.slice(0,16) +'...';
        }
        return value;
    },
    // 倒计时tips提示
    tips: function (el, binding) {
        let  tips;
        let updateTime = 60000; // 60秒
        
        // 1h = 60m = 3600s = 3600X1000ms
        const { startTime, endTime, businessType, stage } = binding.value; // 目标的毫秒级时间戳
        const now = new Date().getTime(); // 当前的毫秒级时间戳
        const starTimer = (startTime - now) / 1000; // 秒级时间戳
        const endTimer = (endTime - now) / 1000; // 秒级时间戳
        const day = Math.floor(endTimer / 3600 / 24);
        const hour = Math.floor((endTimer / 3600) % 24);
        const minute1 = Math.floor((starTimer / 60) % 60);  // 离开始前分钟
        const minute2 = Math.floor((endTimer / 60) % 60);  // 离结束前分钟
        const seconds1 = Math.floor(starTimer % 60);
        const seconds2 = Math.floor(endTimer % 60);
        const limitDay = 2; // 结束天数限制

        /**
         *  不同业务类型考虑范围的提示语：
         *  1. 未开始  (3考试，4调研，5培训班，6直播，7认证考试）提示：还有x分开始
         *  2. 进行中  (1课程，2专题，3考试，4调研，5培训班，7认证考试）提示：x小时x分后结束，  x分后结束，1分钟后结束
         *  3. 已结束 do not tip
         *  备注：
         *      课程 和 专题由于没有任务状态值，无法区分未开始/进行中, 故暂时不在考虑范围；
         *      直播没有截止时间，故只考虑未开始阶段;
         */
        
        if(['未开始','Upcoming'].includes(stage)&&[3,4,5,6,7].includes(businessType)){
            // 开始前1小时内
            if(now<startTime && starTimer <= 3600) { 
                tips  = `还有${minute1}分开始`;
                if (minute1<=5) updateTime = 1000;
                // 没满1分钟 显示1分钟
                if (minute1=== 0 )  tips = '还有1分开始'; 
                if (minute1===0&&seconds1===0) {
                    window.zxyVue.$emit('updateDataList')
                    tips = ""; 
                }
            }
        }

        if(['进行中','In progress'].includes(stage)&&[1,2,3,4,5,7].includes(businessType)){
            // 结束前`limitDay`天内
            if(now>=startTime && now <= endTime && endTimer <= 3600 * 24 * limitDay){
                if (day >= 1) {
                    tips = `${day}天${hour}小时后结束`;
                } else if (hour >= 1 && day < 1) {
                    tips = `${hour}小时${minute2}分钟后结束`;
                } else if (hour < 1) {
                    tips = `${minute2}分钟后结束`;
                    if (minute2<=5) updateTime = 1000;
                    // 没满1分钟 显示1分钟后结束
                    if (minute2=== 0)  tips = '1分钟后结束';  
                    if (minute2===0&&seconds2===0) {
                        window.zxyVue.$emit('updateDataList')
                        tips = ""; 
                    }
                }
            }
        }
        
        tips ?  (el.innerHTML  = tips) : (el.innerHTML  = '');
        return updateTime;
    },
    calcCountDown(me,currTime,endTime) {
        /* 办公主页 监考剩余时间计算
         currTime long
         endTime long
         显示规则：
         剩余时长如果是有超过1天，按照剩余时长：1天12小时23分显示
        1天内：XX小时XX分 
        不超过1小时：XX分*/
        let second = 0; // 秒
        let minute = 0; // 分
        let hour = 0; // 小时
        let day = 0; // 天
        let time = '';
        second = (endTime - currTime) / 1000; // 秒级时间戳

        if (second > 60) {
            minute = window.parseInt(second / 60);
            second = window.parseInt(second % 60);
            if (minute > 60) {
                hour = window.parseInt(minute / 60);
                minute = window.parseInt(minute % 60);
                if (hour > 24) {
                    day = window.parseInt(hour / 24);
                    hour = window.parseInt(hour % 24);
                    minute = window.parseInt(hour % 60);
                }
            }
            if (second >= 30) {
                minute += 1;
            }
        } else if (second >= 30 && second <= 60) {
            minute = 1;
        } else if (second < 30) {
            time = 0 + me.$t('lang.minute');
        }
        if (minute > 0) {
            time = `${minute}${me.$t('lang.minute')}`;
        }
        if (hour > 0) {
            time = `${hour}${me.$t('center.unit_hour')}${time}`;
        }
        if (day > 0) {
            time = `${day}${me.$t('center.unit_day')}${time}`;
        }
        return time;
    },
    calcStudyTime(me,studyTime){
        /*
        studyTime 学习时长 单位秒
        详细时长展示规则为：
        1不足一小时展示为x分(比如5分钟，展示为5分。
        2超过1小时展示为X小时x分（比如1小时5分）。
        3四舍五入，以30秒为界限（比如1分10秒，展示为1分；1分50秒，展示为2分）。
        */
        let time = '';
        let second = 0; // 秒
        let minute = 0; // 分
        let hour = 0; // 小时
        
        second = studyTime === null ? 0 : window.parseInt(studyTime);
        if (second > 60) {
            minute = window.parseInt(second / 60);
            second = window.parseInt(second % 60);
            if (minute > 60) {
                hour = window.parseInt(minute / 60);
                minute = window.parseInt(minute % 60);
            }
            if (second >= 30) {
                minute += 1;
            }
        } else if (second >= 30 && second <= 60) {
            minute = 1;
        } else if (second < 30) {
            time = `0${me.$t('lang.minute')}`;
        }

        if (minute > 0) {
            time = `${minute}${me.$t('lang.minute')}`;
        }
        if (hour > 0) {
            time = `${hour}${me.$t('lang.hour')}${time}`;
        }
        return time;
    },
    // 屏蔽特殊字符
    cleanSpelChar(s){
        var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]") 
        var rs = ""; 
        for (var i = 0; i < s.length; i++) { 
        rs = rs+s.substr(i, 1).replace(pattern, ''); 
        } 
        return rs; 
    }, 
};
